import React, { useEffect, useState } from "react";
import "./Testimonial.css";
import { compose } from "redux";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import TestimonialCard from "../../components/layout/Testimonials/Card";

const PublicTestimonial = (props) => {
  const [part1, setPart1] = useState([]);
  const [part2, setPart2] = useState([]);

  useEffect(() => {
    if (props.testimonials && props.testimonials.length > 0) {
      let part1 = [];
      let part2 = [];
      const middleWareArray = [...props.testimonials];
      const middleIndex = Math.ceil(middleWareArray.length / 2);
      part1 = middleWareArray
        .splice(0, middleIndex)
        .filter((a) => a && Object.keys(a).length > 0);
      part2 = middleWareArray
        .splice(-middleIndex)
        .filter((a) => a && Object.keys(a).length > 0);
      part1 = part1.sort(
        (a, b) => b.modifiedAt.toDate() < a.modifiedAt.toDate()
      );
      part2 = part2.sort(
        (a, b) => b.modifiedAt.toDate() < a.modifiedAt.toDate()
      );
      setPart1(part1);
      setPart2(part2);
    }
  }, [props.testimonials]);
  return (
    <div className="testimonial">
      <div className="testimonialbar"></div>
      <div className="AboutContainer">
        <h1>Testimonial</h1>
        <h3>
          Read what our talented community members are saying about Collegiate
          Sports Advocate.
        </h3>
      </div>
      {props.testimonials && props.testimonials.length < 1 && (
        <p className="not-found cu-center publictestimonial">
          There's No Data Right Now
        </p>
      )}
      <div
        className={`testimonial-section  ${
          props.testimonials && props.testimonials.length < 2 ? "onlyone" : ""
        }`}
      >
        {props.testimonials &&
          props.testimonials.length > 0 &&
          part1 &&
          part1.length > 0 && (
            <div className="testimonial-col">
              {part1.map((testimonial, id) => (
                <TestimonialCard
                  edit={props.superAdmin}
                  data={testimonial}
                  key={id}
                />
              ))}
            </div>
          )}
        {props.testimonials &&
          props.testimonials.length > 0 &&
          part2 &&
          part2.length > 0 && (
            <div className="testimonial-col">
              {part2.map((testimonial, id) => (
                <TestimonialCard
                  edit={props.superAdmin}
                  data={testimonial}
                  key={id}
                />
              ))}
            </div>
          )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  let testimonials = [];
  const testimonialData = state.firestore.ordered.testimonial;
  const athletesData = state.firestore.data.adminAthletes;
  if (
    testimonialData &&
    athletesData &&
    testimonialData.length > 0 &&
    Object.keys(athletesData).length > 0
  ) {
    testimonials = testimonialData.map((e) => {
      let data = null;

      if (e.player && athletesData[e.player]) {
        const athlete = athletesData[e.player];
        data = {
          ...e,
          playerCustomURL: athlete.customUrl,
          playerName: `${athlete.firstName} ${athlete.lastName}`,
        };
      }
      return data;
    });
  }

  // advocateWikiOrder

  return {
    testimonials,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    const firestoreArray = [
      {
        collection: "testimonial",
        orderBy: ["modifiedAt", "desc"],
      },
      {
        collection: "adminAthletes",
      },
    ];
    return firestoreArray;
  })
)(PublicTestimonial);

// {
//   /* <div className="card">
//           <div className="card-body">
//             <img src={Testimonial} alt={Testimonial} />
//             <div className="user-content">
//               <p className="small text-muted mb-0 pl0 line-break-4">
//                 Dribbble has been our primary source when looking for talent,
//                 half of our design team was found within the community. Anyone
//                 looking for top creatives should be using Dribbble.
//               </p>
//             </div>
//           </div>
//           <div className="testimonial-img">
//             <div className="user-picture">
//               <img
//                 src={User}
//                 alt={User}
//                 className=" shadow-sm rounded-circle"
//               />
//             </div>
//             <h5 className="text-capitalize user-name">Emily</h5>
//           </div>
//         </div>
//         <div className="card">
//           <div className="card-body">
//             <div className="user-content">
//               <p className="small text-muted mb-0 pl0 line-break-4">
//                 Dribbble has been our primary source when looking for talent,
//                 half of our design team was found within the community. Anyone
//                 looking for top creatives should be using Dribbble.
//               </p>
//             </div>
//           </div>
//           <div className="testimonial-img">
//             <div className="user-picture">
//               <img
//                 src={User}
//                 alt={User}
//                 className=" shadow-sm rounded-circle"
//               />
//             </div>

//             <h5 className="text-capitalize user-name">AnnRaubuch</h5>
//           </div>
//         </div> */
// }
